import * as types from '../constants/actionTypes';

export function createFloatingTask({floatingTask, status, data} = {}) {
    return {
        type: types.CREATE_FLOATING_TASK
        , floatingTask
        , status
        , data
    };
}
export function createTimer({floatingTask, logEntry, status, data} = {}) {
    return {
         type: types.CREATE_FLOATING_TIMER
         , floatingTask
         , logEntry
         , status
         , data
    };
}
export function deleteFloatingTask({floatingTaskID, status, data} = {}) {
    return {
        type: types.DELETE_FLOATING_TASK
        , floatingTaskID
        , status
        , data
    };
}
export function isDeletable({floatingTaskID, status, data} = {}) {
    return {
        type: types.IS_DELETABLE_FLOATING_TASK
        , floatingTaskID
        , status
        , data
    };
}
export function invalidateFloatingTask({floatingTaskID, status, data} = {}) {
    return {
        type: types.INVALIDATE_FLOATING_TASK
        , floatingTaskID
        , status
        , data
    };
}
export function loadAllFloatingTasks({status, data} = {}) {
    return {
        type: types.LOAD_ALL_FLOATING_TASKS
        , status
        , data
    };
}
export function mergeFloatingTaskExisting({loatingTaskID, taskID, status, data} = {}) {
    return {
        type: types.MERGE_FLOATING_TASK_EXISTING
        , loatingTaskID
        , taskID
        , status
        , data
    };
}
export function mergeFloatingTaskNew({floatingTaskID, task, quota, status, data} = {}) {
    return {
        type: types.MERGE_FLOATING_TASK_NEW
        , floatingTaskID
        , task
        , quota
        , status
        , data
    };
}
export function pmLoadAllFloatingTasks({status, data} = {}) {
    return {
        type: types.PM_LOAD_ALL_FLOATING_TASKS
        , status
        , data
    };
}
export function pmoDeleteFloatingTask({floatingTaskID, status, data} = {}) {
    return {
        type: types.PMO_DELETE_FLOATING_TASK
        , floatingTaskID
        , status
        , data
    };
}
export function pmoLoadAllFloatingTasks({status, data} = {}) {
    return {
        type: types.PMO_LOAD_ALL_FLOATING_TASKS
        , status
        , data
    };
}
export function reassignFloatingTask({floatingTaskID, manager, message, status, data} = {}) {
    return {
        type: types.REASSIGN_FLOATING_TASK
        , floatingTaskID
        , manager
        , message
        , status
        , data
    };
}
export function returnFloatingTask({floatingTaskID, message, status, data} = {}) {
    return {
        type: types.RETURN_FLOATING_TASK
        , floatingTaskID
        , message
        , status
        , data
    };
}
export function validateFloatingTask({floatingTaskID, status, data} = {}) {
    return {
        type: types.VALIDATE_FLOATING_TASK
        , floatingTaskID
        , status
        , data
    };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/floatingTaskActions.js
 **/